import {
	DocumentIcon,
	QuestionIcon,
	SpeechIcon,
} from "@logora/parliament.icons.regular_icons";
import { StatBox } from "@logora/parliament.ui.stat_box";
import { Box } from "@mui/material";
import React from "react";
import { useDataProvider } from "react-admin";
import useFetchStats from "../stats/useFetchStats";

export const ActeurDashboard = ({ acteur }) => {
	const dataProvider = useDataProvider();
	const {
		stats,
		loading: statsLoading,
		error: statsError,
	} = useFetchStats(
		dataProvider,
		acteur.chambre,
		"LEGISLATURE",
		"17",
		"ACTEUR",
	);
	if (!statsLoading && !statsError && Object.keys(stats).length > 0) {
		return (
			<Box
				display="grid"
				gridTemplateColumns="repeat(auto-fit, minmax(300px, 1fr))"
				marginTop="2em"
				gap="2em"
			>
				{stats.amendements?.moyenne !== 0 && (
					<StatBox
						icon={<DocumentIcon />}
						mainStat={acteur.nombreAmendements}
						text="amendements déposés"
						average={stats.amendements?.moyenne ?? 0}
						maxValue={stats.amendements?.maximum ?? 0}
					/>
				)}
				{stats.interventions?.moyenne !== 0 && (
					<StatBox
						icon={<SpeechIcon />}
						mainStat={acteur.nombreInterventions}
						text="interventions en hémicycle"
						average={stats.interventions?.moyenne ?? 0}
						maxValue={stats.interventions?.maximum ?? 0}
					/>
				)}
				{stats.questions?.moyenne !== 0 && (
					<StatBox
						icon={<QuestionIcon />}
						mainStat={acteur.nombreQuestions}
						text="questions posées"
						average={stats.questions?.moyenne ?? 0}
						maxValue={stats.questions?.maximum ?? 0}
					/>
				)}
			</Box>
		);
	}
};
